import React from 'react';
import './TopBarButton.css';

const TopBarButton = (props: {children: React.ReactNode}) => (
  <button className="top_bar_button">{props.children}</button>
)

export default TopBarButton;